import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import { FunctionComponent } from 'react';

export type { CheckboxProps };

export const Checkbox: FunctionComponent<CheckboxProps> = (props) => {
  return <AntdCheckbox className="the5ers-checkbox" {...props} />;
};
